export default "__VITE_ASSET__BVM8EtCR__"